import { qsAll } from '../dom-helpers';

class FloatingLabels {
  constructor() {
    this.formInputs = qsAll('.input-text:not(.qty):not(.not-floating)');
    this.formLabels = qsAll('.form-row .input-label');

    if (!this.formInputs.length) return;

    this._run();
  }

  static updateInputState(input) {
    const paragraphWrapper = input.closest('p.form-row');

    if (!input.value) {
      paragraphWrapper.classList.remove('form__input-filled');
    } else {
      paragraphWrapper.classList.add('form__input-filled');
    }
  }

  static makeLabelActive(input) {
    const paragraphWrapper = input.closest('p.form-row');
    paragraphWrapper.classList.add('form__input-filled');
  }

  static makeLabelInactive(input) {
    const paragraphWrapper = input.closest('p.form-row');
    paragraphWrapper.classList.remove('form__input-filled');
  }

  _run() {
    this.formInputs.forEach((input) => {
      FloatingLabels.updateInputState(input);

      input.addEventListener('input', () => {
        FloatingLabels.updateInputState(input);
      });

      input.addEventListener('focus', () => {
        FloatingLabels.makeLabelActive(input);
      });

      input.addEventListener('blur', () => {
        FloatingLabels.updateInputState(input);
      });
    });
  }
}

export default FloatingLabels;
